export const TAG = 'TAG';
export const STYLE = 'STYLE';
export const YEAR = 'YEAR';
export const COUNTRY = 'COUNTRY';
export const YOUTUBE = 'YOUTUBE';
export const DISCOGS = 'DISCOGS';
